import { httpV1 as http } from '@/services/api';

export function emptyPromoterDetails() {
  return {
    operationModel: null,
    geographicArea: null,
    sellerCount: null,
    weeklyPaidProposals: null,
    salesVolumeMonth1: null,
    salesVolumeMonth2: null,
    salesVolumeMonth3: null,
    declaredCompetitors: null,
    partnerNote: null,
    productsSold: [],
    crmStatus: null,
  };
}

// GET returns { data: "-" } when the promotora has no details yet — not an error.
export function fromApiPayload(body) {
  const record = body?.data;
  if (!record || record === '-') return emptyPromoterDetails();

  return {
    operationModel: record.operating_model ?? null,
    geographicArea: record.geographic_scope ?? null,
    sellerCount: record.sellers_count ?? null,
    weeklyPaidProposals: record.paid_proposals_week ?? null,
    salesVolumeMonth1: record.declared_sales_volume_month_1 ?? null,
    salesVolumeMonth2: record.declared_sales_volume_month_2 ?? null,
    salesVolumeMonth3: record.declared_sales_volume_month_3 ?? null,
    declaredCompetitors: record.declared_competitors ?? null,
    partnerNote: record.partner_notes ?? null,
    productsSold: record.products_sold ?? [],
    crmStatus: record.crm_status ?? null,
  };
}

export function toApiPayload(details) {
  return {
    operating_model: details.operationModel ?? null,
    geographic_scope: details.geographicArea ?? null,
    sellers_count: details.sellerCount ?? null,
    paid_proposals_week: details.weeklyPaidProposals ?? null,
    declared_sales_volume_month_1: details.salesVolumeMonth1 ?? null,
    declared_sales_volume_month_2: details.salesVolumeMonth2 ?? null,
    declared_sales_volume_month_3: details.salesVolumeMonth3 ?? null,
    declared_competitors: details.declaredCompetitors ?? null,
    partner_notes: details.partnerNote ?? null,
    products_sold: details.productsSold ?? [],
    crm_status: details.crmStatus ?? null,
  };
}

export async function getPromoterDetails(promoterId) {
  return http
    .get(`/promoters/${promoterId}/details`)
    .then(({ data }) => fromApiPayload(data));
}

export async function savePromoterDetails(promoterId, details) {
  return http
    .put(`/promoters/${promoterId}/details`, toApiPayload(details))
    .then(({ data }) => fromApiPayload(data));
}
